export function oidcUserProfileExists() {
  return !!loadOidcUserProfile();
}

export function saveOidcUserProfile(profile) {
  sessionStorage.setItem(oidcUserKey(), JSON.stringify(profile));
}

export function loadOidcUserProfile() {
  return JSON.parse(sessionStorage.getItem(oidcUserKey()));
}

export function oidcAccessTokenExists() {
  return !!loadOidcAccessToken();
}

export function saveOidcAccessToken(accessToken) {
  sessionStorage.setItem(oidcAccessTokenKey(), JSON.stringify(accessToken));
}

export function loadOidcAccessToken() {
  const accessTokenKeya = sessionStorage.getItem(oidcAccessTokenKey());
  if (accessTokenKeya !== 'undefined') {
    return JSON.parse(sessionStorage.getItem(oidcAccessTokenKey()));
  } else {
    return '';
  }
}

export function loadComplianceRoles() {
  if (oidcAccessTokenExists()) {
    const token = loadOidcAccessToken()
    const [, payloadBase64] = token?.split('.');
    const decodedPayload = JSON.parse(window.atob(payloadBase64));
    if (decodedPayload.resource_access.compliance) {
      return decodedPayload.resource_access.compliance.roles[0];
    } else {
      return null;
    }
  } else {
    return null;
  }
}

export function saveOidcAccessTokenExpiresAt(expiresAt) {
  sessionStorage.setItem(oidcExpiresAtKey(), JSON.stringify(expiresAt));
}

export function loadOidcAccessTokenExpiresAt() {
  return JSON.parse(sessionStorage.getItem(oidcExpiresAtKey()));
}

export function clearOidcInformation() {
  console.info('removendo informações oidc de storage...');
  sessionStorage.removeItem(oidcUserKey());
  sessionStorage.removeItem(oidcAccessTokenKey());
  sessionStorage.removeItem(oidcExpiresAtKey());
  console.info('informações oidc removidas.');
}

function oidcUserKey() {
  return `oidc_user:${process.env.REACT_APP_AUTHORITY}:${process.env.REACT_APP_CLIENT_ID}`;
}

function oidcAccessTokenKey() {
  return `oidc_access_token:${process.env.REACT_APP_AUTHORITY}:${process.env.REACT_APP_CLIENT_ID}`;
}

function oidcExpiresAtKey() {
  return `oidc_expires_at:${process.env.REACT_APP_AUTHORITY}:${process.env.REACT_APP_CLIENT_ID}`;
}
